import React from 'react';
import moment from 'moment-timezone';
import renderHTML from 'react-render-html';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { billActionCreators } from '../../../stores/lis-legislation-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { patronActionCreators } from '../../../stores/lis-patron-store';
import { voteActionCreators } from '../../../stores/lis-votes-store';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { orgActionCreators } from '../../../stores/lis-org-store';
import { cancelRequest } from '../../../services/request.service';
import '../../../stylesheets/lis-public-view/public-view.css';
import LoaderComponent from '../../../lis-shared/lis-layout/components/lis-loader-component';
import BillHistoryForm from './lis-history-form';
import ImpactStatementForm from './lis-impact-statements';
import Collections from './lis-collections';
import queryString from 'query-string';
import { minutesActionCreators } from '../../../stores/lis-minutes-store';
import { memberActionCreators } from '../../../stores/lis-members-store';
import VersionList from '../../../lis-shared/lis-bills/lis-bill-version-list';
import { Editor } from '@tinymce/tinymce-react';
import { collectionActionCreators } from '../../../stores/lis-collection-store';
import ReportMaker from '../lis-bill-search/lis-report-maker';
import { printBillDetails } from '../../../services/legislation-helper-service';

const BILL_EVENT_VIEWER = "LegislationEvent";
const BILL_EVENT_AUTHOR = "LegislationEventHistory";
const BILL_COLLECTION_AUTHOR = "LegislationCollections";
const BILL_AUTHOR = "Legislation";
const VERSION_AUTHOR = "LegislationText";
const PATRON_AUTHOR = "LegislationPatron";

const SUMMARY = "summary";
const DESCRIPTION = "description";

const isStatic = window.location.pathname.includes('static');

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0.12em 0.6em !important',
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px'
    }),
    multiValue: styles => ({
        ...styles,
        maxWidth: "300px"
    })
}

function PatronName(props) {
    return (
        <Link to={`/session-details/${props.session.SessionCode}/member-information/${props.MemberNumber}/member-details`}>{props.MemberDisplayName}{props.ByRequest && props.DisplayName ? ' ' + props.DisplayName.replace(')', ', By Request)') : props.DisplayName ? ' ' + props.DisplayName : props.ByRequest ? ' (By Request)' : null}</Link>
    );
}

function PatronList(props) {
    var patronsLength = props.patrons.length;
    const listPatrons = props.patrons.map((patrons, i) => {
        if (props.list) {
            return <li><PatronName session={props.session} key={i} {...patrons} /></li>
        } else if (patronsLength === i + 1) {
            return <PatronName session={props.session} key={i} {...patrons} />
        } else {
            return <span key={i}><PatronName session={props.session} {...patrons} />, </span>
        }
    });
    return props.list ? <ul className="list-two no-list-style">{listPatrons}</ul> : <span>{listPatrons}</span>;
}

class OldBillDetailsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            billData: '',
            historyList: [],
            summariesList: [],
            housePatronsList: [],
            senatePatronsList: [],
            versionsList: [],
            chiefPatronsList: [],
            sessionData: '',
            toolTip: false,
            editingHistory: false,
            billEvents: [],
            organizedEvents: [],
            actionTypes: [],
            memberList: [],
            committeeList: [],
            editing: {},
            description: "",
            saving: false,
            displayStatementForm: false,
            statementSubmitting: false,
            statementLegislationTextID: '',
            statementDate: '',
            statementDescription: '',
            agencyOptions: [],
            statementDocumentcode: '',
            reconsiderationEvents: [],
            hideAllEvents: true,
            patronList: [],
            collections: [],
            collectionIsLoading: false,
            showPopup: false,
            watchlists: [],
            selectedWatchlists: [],
            showWatchlistForm: false,
            noteWatchlists: [],
            noteText: "",
            showWatchlistList: false,
            showReportMaker: false
        };
        this.setupPage = this.setupPage.bind(this);
        this.getBillDetails = this.getBillDetails.bind(this);
        this.getPatrons = this.getPatrons.bind(this);
        this.getBillVersion = this.getBillVersion.bind(this);
        this.toggleShowLinks = this.toggleShowLinks.bind(this);
        this.toggleEditContent = this.toggleEditContent.bind(this);
        this.handleEventChange = this.handleEventChange.bind(this);
        this.saveEvents = this.saveEvents.bind(this);
        this.changeToNewBillHistoryForm = this.changeToNewBillHistoryForm.bind(this);
        this.saveDescription = this.saveDescription.bind(this);
        this.saveSummary = this.saveSummary.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleStatementForm = this.toggleStatementForm.bind(this);
        this.submitImpactStatement = this.submitImpactStatement.bind(this);
        this.closeStatementForm = this.closeStatementForm.bind(this);
        this.getReconsiderationEvents = this.getReconsiderationEvents.bind(this);
        this.togglehideAllEvents = this.togglehideAllEvents.bind(this);
        this.checkForDuplicates = this.checkForDuplicates.bind(this);
        this.togglePatronModal = this.togglePatronModal.bind(this);
        this.handleWatchlistChange = this.handleWatchlistChange.bind(this);
        this.handleSaveWatchlistss = this.handleSaveWatchlistss.bind(this);
        this.addToWatchlists = this.addToWatchlists.bind(this);
        this.getCollections = this.getCollections.bind(this);
        this.handleToggleDescriptionEdit = this.handleToggleDescriptionEdit.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.saveVersionDescription = this.saveVersionDescription.bind(this);
        this.handleNoteTextChange = this.handleNoteTextChange.bind(this);
        this.handleNoteWatchlistChange = this.handleNoteWatchlistChange.bind(this);
        this.handleSaveWatchlists = this.handleSaveWatchlists.bind(this);
        this.toggleWatchlistList = this.toggleWatchlistList.bind(this);
        this.handleRemoveWatchlists = this.handleRemoveWatchlists.bind(this);
        this.addCommitteeLink = this.addCommitteeLink.bind(this);
        this.toggleReportMaker = this.toggleReportMaker.bind(this);
        this.handleSaveWatchlist = this.handleSaveWatchlist.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.printRef = React.createRef();
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        const sessionCode = this.props.params.sessionCode;
        let legislationNumber = this.props.params.billnumber;

        //if legislation number is zero-padded (such as from a calendar), remove the zero-padding
        const legislationNumberDigitsWithZeroPadding = legislationNumber.match(/\d+/); //e.g. 0259
        if (legislationNumberDigitsWithZeroPadding) {
            const legislationNumberDigitsWithOutZeroPadding = parseInt(legislationNumberDigitsWithZeroPadding[0]); //turns 0259 into 259
            legislationNumber = legislationNumber.replace(/\d+/, legislationNumberDigitsWithOutZeroPadding); //turns HB0259 into HB259
        }

        this.setupPage(sessionCode, legislationNumber);
    }

    componentDidUpdate(prevProps) {
        const sessionCode = this.props.params.sessionCode;
        const legislationNumber = this.props.params.billnumber;
        const previousSessionCode = prevProps.params.sessionCode;
        const previousLegislationNumber = prevProps.params.billnumber;
        if (previousSessionCode !== sessionCode || previousLegislationNumber !== legislationNumber) {
            this.setState({
                historyIsLoaded: false,
                summaryIsLoaded: false,
                versionsIsLoaded: false,
                patronIsLoaded: false,
                billDataIsLoaded: false
            }, () => {
                this.setupPage(sessionCode, legislationNumber);
            })
        } else if (JSON.stringify(prevProps.login.userClaims.resources) !== JSON.stringify(this.props.login.userClaims.resources)) {
            this.setState({
                historyIsLoaded: false
            }, () => {
                if (!this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR)) {
                    this.setState({ editing: {} })
                }
                this.setupPage(sessionCode, legislationNumber);
            })
        }

        if (!this.state.switchedToBill && prevProps.location.search !== this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            if (parsed.openBillHistory) {
                this.setState({
                    switchedToBill: true
                });
            }
        }
        if (this.state.billDataIsLoaded && (Array.isArray(this.state.billData) && !this.state.billData[0] || !this.state.billData)) {
            let legislationNumber = this.props.params.billnumber;
            const param = {
                selectedBillNumbers: legislationNumber,
                selectedKeywords: "",
                selectedSession: this.props.session.selectedSession.SessionID,
                selectedChapterNumber: "",
                includeFailed: true
            }
            const encoded = window.btoa(JSON.stringify(param));
            this.props.history.push('/bill-search?q=' + encoded);
        }
    }

    setupPage(sessionCode, legislationNumber) {
        this.props.actions.getSessionByCode(sessionCode).then(() => {
            if (this.props.session.selectedSession) {
                this.setState({
                    sessionData: this.props.session.selectedSession,
                    conveneDate: this.props.session.selectedSession.SessionStart,
                    legislationNumber: legislationNumber
                }, () => {
                    this.getBillDetails(legislationNumber, sessionCode);
                    this.getBillSummary(legislationNumber, sessionCode);
                    this.getBillVersion(legislationNumber, sessionCode);
                });
                this.props.actions.getCommitteeList('sessionID=' + this.props.session.selectedSession.SessionID + "&includeSubCommittees=true").then(() => {
                    let committeeList = this.props.committee.committeeList;
                    committeeList.forEach(committee => {
                        committee.label = committee.Name;
                        committee.value = committee.CommitteeID;
                        committee.abbrev = committee.Abbreviation;
                    });
                    this.setState({
                        committeeList: committeeList
                    });
                });
            }
        }).catch(err => {
            if (err === "Aborted") {
                return;
            }
            this.setState({
                billDataIsLoaded: true,
                patronIsLoaded: true,
                historyIsLoaded: true,
                billData: ''
            });
        });
        //This is if a user is signed in with the correct roles they can edit the events
        const chamberCode = legislationNumber[0];
        this.props.actions.getBillEvents('?LegislationChamberCode=' + chamberCode)
            .then(() => {
                let billEvents = [...this.props.bills.billEvents];
                billEvents.forEach(evt => {
                    evt.label = evt.LegislationDescription;
                    evt.value = `${evt.LegislationEventTypeID}-${evt.IsPassed}`
                });
                this.setState({
                    billEvents: billEvents
                });
            });
        this.props.actions.getMemberList('sessionCode=' + sessionCode).then(() => {
            let memberList = [...this.props.members.memberList];
            memberList.forEach(member => {
                member.label = member.PatronDisplayName;
                member.value = member.MemberID;
            });
            this.setState({
                memberList: memberList
            });
        });
        this.props.actions.getActionTypes()
            .then(() => {
                let actionTypes = [...this.props.minutes.actionTypes];
                actionTypes.forEach(type => {
                    type.label = type.ActionReferenceType;
                    type.value = type.ActionReferenceTypeID;
                })
                this.setState({
                    actionTypes: actionTypes
                });
            });
        this.props.actions.getAgencyList().then(() => {
            let agencies = [...this.props.organizations.agencyList]
            agencies.forEach((agency, i) => {
                agency.label = agency.AgencyName + " (" + agency.Abbreviation + ")";
                agency.value = agency.AgencyNumber
            })
            this.setState({
                agencyOptions: agencies
            })
        })
    }

    componentWillUnmount() {
        // If redirecting because no result, then do not abort requests. It will throw errors
        if (this.state.billDataIsLoaded && (Array.isArray(this.state.billData) && !this.state.billData[0] || !this.state.billData)) {
            cancelRequest();
        }
    }

    // RETRIEVE PATRONS FOR A BILL
    getPatrons(billID, chamberCode) {
        this.props.actions.getPatronList(billID).then(() => {
            let senatePatronsList = this.props.patrons.senatePatronsList;
            let housePatronsList = this.props.patrons.housePatronsList;
            let chiefPatronsList = this.props.patrons.chiefPatronsList;
            let patronList = this.props.patrons.patronList;
            let originalPatronList = this.props.patrons.patronList;
            if (chamberCode === 'H' && chiefPatronsList && chiefPatronsList.length > 1) {
                for (let i = 1; i < chiefPatronsList.length; i++) {
                    if (chiefPatronsList[i].ChamberCode === 'S') {
                        senatePatronsList.unshift(chiefPatronsList[i]);
                    } else {
                        housePatronsList.unshift(chiefPatronsList[i]);
                    }
                    chiefPatronsList.splice(i, 1);
                    i--;
                }
            }

            housePatronsList.sort((a, b) => { return a.Sequence > b.Sequence ? 1 : b.Sequence > a.Sequence ? -1 : a.PatronDisplayName > b.PatronDisplayName ? 1 : -1 });
            senatePatronsList.sort((a, b) => { return a.Sequence > b.Sequence ? 1 : b.Sequence > a.Sequence ? -1 : a.PatronDisplayName > b.PatronDisplayName ? 1 : -1 });

            this.setState({
                senatePatronsList,
                housePatronsList,
                chiefPatronsList,
                patronList,
                originalPatronList,
                patronIsLoaded: true
            }, () => {
                if (this.props.location.state && this.props.location.state.expandPatrons && chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1) {
                    this.toggleShowData('slidePatron');
                }
            })
        }
        )
    }

    // RETRIEVE BILL SUMMARIES
    getBillSummary(billNumber, sessionCode) {
        const params = '?sessionCode=' + sessionCode + '&legislationNumber=' + billNumber;
        this.props.actions.getBillSummary(params).then(() => {
            this.setState({
                summariesList: this.props.bills.billSummary.sort((a, b) => { return b.SummaryVersionID - a.SummaryVersionID }),
                summaryIsLoaded: true
            });
        });
    }

    // RETRIEVE BILL VERSIONS
    getBillVersion(billNumber, sessionCode) {
        const partner = this.props.login.userClaims.resources.find(resource => resource === VERSION_AUTHOR)
        var params = '?isPublic=' + !partner + '&legislationNumber=' + billNumber + '&sessionCode=' + sessionCode;
        this.props.actions.getBillText(params, partner).then(() =>
            this.setState({
                versionsList: [...this.props.bills.billText].filter(v => !v.SessionCode || v.SessionCode === sessionCode),
                versionsIsLoaded: true
            }, () => {
                if (this.props.login.userClaims.scopes.findIndex(x => x === "House") > -1 || this.props.login.userClaims.scopes.findIndex(x => x === "Senate") > -1 || this.props.login.userClaims.roles.findIndex(x => x === "DLSStaff") > -1) {
                    this.setState({
                        slideVersions: true
                    })
                }
            })
        );
    }

    // RETRIEVE THE BILL HISTORY (BILL EVENTS)
    getBillHistory(legislationID, sessionCode) {
        let partner = false;
        let partnerEditor = false;
        //Only use the partner endpoint if the user looking at the bill text is authorized to edit it or is supposed to see non-public events
        if (this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR)) {
            partner = true;
            partnerEditor = true;
        } else if (this.props.login.userClaims.resources.find(resource => resource === BILL_EVENT_VIEWER)) {
            partner = true;
        }

        let params = '?legislationID=' + legislationID + "&sessionCode=" + sessionCode;
        this.props.actions.getBillHistoryByBillID(params, partner)
            .then(() => {
                this.setState({
                    historyList: this.props.bills.billHistory,
                    historyIsLoaded: true
                }, () => {
                    if (partnerEditor) {
                        const parsed = queryString.parse(this.props.location.search);
                        if (parsed.openBillHistory) {
                            this.setState({
                                switchedToBill: true,
                                editingHistory: true
                            });
                        }
                    } else {
                        this.setState({
                            editingHistory: false
                        })
                    }
                })
            });
    }

    getReconsiderationEvents(params) {
        params = '?ReconsiderationAction=' + params + '&LegislationID=' + this.state.billData.LegislationID;

        this.props.actions.getLegislationEventsByLegislationId(params)
            .then(() => {
                this.setState({
                    reconsiderationEvents: this.props.bills.legislationEventsById
                });
            })
    }

    // RETRIEVE THE BILL DETAILS
    getBillDetails(billId, sessionCode) {
        const params = {
            SessionCode: sessionCode,
            LegislationNumbers: [{ LegislationNumber: billId }],
        };

        this.props.actions.getBillList(params).then(() => {
            if (this.props.bills.billList[0]) {
                this.setState({
                    billData: this.props.bills.billList[0],
                    billDataIsLoaded: true,
                }, () => {
                    this.getPatrons(this.state.billData.LegislationID, this.state.billData.ChamberCode);
                    this.getBillHistory(this.state.billData.LegislationID, this.state.billData.SessionCode);
                });
            } else {
                //The bill cannot be found. Everything has stopped loading so set them to true. A message will be displayed to the user that the bill was not found
                this.setState({
                    billDataIsLoaded: true,
                    patronIsLoaded: true,
                    historyIsLoaded: true,
                    billData: ''
                });
            }
        });
    }

    // TOGGLE SHOW 'ALL' SLIDEDOWNS
    toggleShowData(slide) {
        this.setState(prevState => ({
            [slide]: !prevState[slide]
        }));
    }

    // TOGGLE THE INFO TOOLTIP
    toggleShowTooltip() {
        this.setState(state => ({
            toolTip: !state.toolTip
        }));
    }

    // TOGGLE THE 'ALL HISTORY' ARROW
    toggleShowLinks(vote, sessionCode) {
        let historyList = [...this.state.historyList];
        const historyIndex = historyList.findIndex(item => item.LegislationEventID == vote.LegislationEventID);

        historyList[historyIndex].opened = !historyList[historyIndex].opened;
        if (vote.VoteLinks) {
            this.setState({
                historyList: historyList
            });
        } else {
            historyList[historyIndex].isLoading = true;
            this.setState({ historyList: historyList });
            let params = '?legislationEventID=' + vote.LegislationEventID;
            this.props.actions.getVoteLink(params).then(() => {
                let links = [...this.props.votes.voteLinkResponse];
                let linkPromises = [];
                links.forEach(link => {
                    if (link.CommitteeID) {
                        const cmtePromise = this.props.actions.getCommitteeById("?id=" + link.CommitteeID + "&sessionCode=" + vote.SessionCode)
                            .then(() => {
                                link.CommitteeNumber = this.props.committee.committeeByIdData.CommitteeNumber;
                            }).catch((err) => {
                                console.error(err);
                                // Don't care if it fails. That committee won't be visible
                                return Promise.resolve();
                            })
                        linkPromises.push(cmtePromise);
                    }
                    // If there are any vote links of type 'Legislation' then the legislation ID needs to be turned into a legislation number to form the link
                    if (link.ReferenceType === "Legislation") {
                        const promise = this.props.actions.getBill(link.ReferenceID)
                            .then(() => {
                                link.LegislationNumber = this.props.bills.bill.LegislationNumber;
                                link.SessionCode = link.SessionCode || vote.SessionCode;
                                return Promise.resolve();
                            }).catch(err => {
                                console.error(err);
                                // Don't care if it fails. That legislation won't be visible
                                return Promise.resolve();
                            });
                        linkPromises.push(promise);
                    }
                });
                Promise.all(linkPromises)
                    .then(() => {
                        historyList[historyIndex].isLoading = false;
                        historyList[historyIndex].VoteLinks = this.props.votes.voteLinkResponse;
                        this.setState({
                            historyList: historyList
                        });
                    });
            });
        }
    }

    toggleEditContent() {
        this.setState(state => ({
            editingHistory: !state.editingHistory
        }), () => {
            //some browsers do not support the :has() css selector, which is how we remove (i.e. set display: none) the footer-wrapper when editing events.
            //in these instances, we rely on the below js to accomplish the same.
            const footer = document.getElementsByClassName("footer-wrapper");
            if (footer && footer[0]) {
                const unsupportedBrowser = (this.state.editingHistory && window.getComputedStyle(footer[0]).display === 'block') || (!this.state.editingHistory && footer[0].style.display === 'none');
                if (unsupportedBrowser) {
                    if (this.state.editingHistory) {
                        footer[0].style.display = 'none';
                    } else {
                        footer[0].style.display = '';
                    }
                }
            }
        });
    }

    toggleStatementForm(statementDate, statementDescription, documentCode) {
        if (!this.state.displayStatementForm) {
            this.setState({
                displayStatementForm: true,
                statementDate: statementDate,
                statementDescription: statementDescription,
                statementDocumentcode: documentCode
            });
        } else {
            this.setState({
                displayStatementForm: false,
                statementDate: "",
                statementDescription: "",
                statementDocumentcode: ""
            });
        }
    }

    closeStatementForm() {
        this.setState({
            displayStatementForm: false
        }, () => {
            //Refresh the page to show the new impact statement in the version list
            const sessionCode = this.props ? this.props.params.sessionCode : this.props.selectedBillSession;
            const legislationNumber = this.props ? this.props.params.billnumber : this.props.selectedBill;
            this.setupPage(sessionCode, legislationNumber);
        })
    }

    handleEventChange(organizedEvents, callback) {
        this.setState({
            organizedEvents: organizedEvents
        }, () => {
            if (callback) {
                callback();
            }
        });
    }

    saveEvents(eventsToSave, callback) {
        if (eventsToSave.length > 0) {
            this.props.actions.saveBillEvent({ LegislationEvents: eventsToSave })
                .then(() => {
                    this.props.actions.makeToast([{ message: "Events Saved", type: "success" }]);
                    this.props.actions.getBillHistoryByBillID('?legislationID=' + this.state.billData.LegislationID + "&sessionCode=" + this.state.billData.SessionCode, true)
                        .then(() => {
                            this.setState({
                                historyList: this.props.bills.billHistory,
                            }, () => callback(true))
                        });
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    let msg;
                    if (err) {
                        try {
                            const errJson = JSON.parse(err);
                            if (errJson && errJson.Name) {
                                msg = errJson.Name
                            }
                        } catch (e) { /*do nothing*/ }
                    }
                    this.props.actions.makeToast([{ message: msg && msg.toLowerCase().includes("unable to delete referral") ? msg : "Events Save Failed", type: "failure" }]);
                    this.props.actions.getBillHistoryByBillID('?legislationID=' + this.state.billData.LegislationID + "&sessionCode=" + this.state.billData.SessionCode, true)
                        .then(() => {
                            this.setState({
                                historyList: this.props.bills.billHistory,
                            }, () => callback(false))
                        });
                })
        } else {
            // If there  are no events to save then just show the save succesful banner after a second to give the illusion something happened.
            setTimeout(() => {
                this.props.actions.makeToast([{ message: "Events Saved", type: "success" }]);
                callback(false)
            }, 1000)
        }
    }

    changeToNewBillHistoryForm(billNum) {
        this.props.history.push(`/bill-details/${this.state.sessionData.SessionCode}/${billNum}/?openBillHistory=true`)
    }

    saveDescription() {
        let saving = { ...this.state.saving };
        saving[DESCRIPTION] = true;
        this.setState({
            saving
        }, () => {
            //Partner get bill request to get the mod date
            this.props.actions.getBill(this.state.billData.LegislationID, true)
                .then(() => {
                    let modifiedBillData = { ...this.props.bills.bill };
                    modifiedBillData.Description = this.state.description;

                    this.props.actions.saveBill({ LegislationList: [modifiedBillData] })
                        .then(() => {
                            this.props.actions.makeToast([{ message: "Description Saved", type: "success" }]);
                            let newBillData = { ...this.state.billData }
                            newBillData.Description = this.state.description;
                            let editing = { ...this.state.editing };
                            editing[DESCRIPTION] = false;
                            saving[DESCRIPTION] = false;
                            this.setState({
                                editing,
                                saving,
                                billData: newBillData
                            });
                        }).catch(err => {
                            if (err === 'Aborted') {
                                return;
                            }
                            this.props.actions.makeToast([{ message: "Description Save Failed", type: "failure" }]);
                            let editing = { ...this.state.editing };
                            editing[DESCRIPTION] = false;
                            saving[DESCRIPTION] = false;
                            this.setState({
                                editing: editing,
                                saving: saving
                            });
                        });
                })
        })
    }

    saveSummary(index, deletion) {
        let saving = { ...this.state.saving };
        if (!saving[SUMMARY]) {
            saving[SUMMARY] = {};
        }
        saving[SUMMARY][index] = true;
        this.setState({
            saving
        }, () => {
            let summariesList = [...this.state.summariesList];
            //Partner get summary request to get the mod date
            this.props.actions.getBillSummary('/' + summariesList[index].LegislationSummaryID, true)
                .then(() => {
                    let modifiedSummaryData = [...this.props.bills.billSummary];
                    if (deletion) {
                        //Turn IsActive and IsPublic is false, and that will prevent the DB from turning one or the other true in the future
                        modifiedSummaryData[0].IsActive = false;
                        modifiedSummaryData[0].IsPublic = false;
                    } else {
                        modifiedSummaryData[0].Summary = this.state.summary[index];
                    }
                    this.props.actions.saveBillSummary({ SummaryList: modifiedSummaryData })
                        .then(() => {
                            this.props.actions.makeToast([{ message: "Summary " + (deletion ? "Removed" : "Saved"), type: "success" }]);
                            let editing = { ...this.state.editing };
                            let summary = { ...this.state.summary };
                            if (deletion) {
                                //remove from the UI and reset the editing/saving/summary values to avoid indexing problems
                                this.toggleDeleteSummaryModal();
                                summariesList.splice(index, 1);
                                saving = {};
                                editing = {};
                                summary = {};
                            } else {
                                summariesList[index] = this.props.bills.billSummarySave[0];
                                saving[SUMMARY][index] = false;
                                if (editing[SUMMARY] && editing[SUMMARY][index]) {
                                    editing[SUMMARY][index] = false;
                                }
                            }
                            this.setState({
                                summariesList,
                                summary,
                                editing,
                                saving
                            });
                        }).catch(err => {
                            if (err === 'Aborted') {
                                return;
                            }
                            console.error(err)
                            this.props.actions.makeToast([{ message: "Summary Save Failed", type: "failure" }]);
                            let editing = { ...this.state.editing };
                            let saving = { ...this.state.saving };
                            let summary = { ...this.state.summary };
                            editing = {};
                            saving = {};
                            summary = {};
                            this.setState({
                                summary,
                                editing: editing,
                                saving: saving
                            });
                        });
                })
        })
    }

    toggleEdit(key, value, index) {
        let editing = { ...this.state.editing };
        if (key === SUMMARY) {
            if (!editing[key]) {
                editing[key] = {};
            }
            editing[key][index] = !editing[key][index];
            let keyState = { ...this.state[key] };
            keyState[index] = value;
            this.setState({
                editing,
                [key]: keyState
            })
        } else {
            editing[key] = !editing[key];
            this.setState({
                editing,
                [key]: value
            })
        }
    }

    handleChange(key, e, index) {
        if (key === SUMMARY) {
            let keyState = { ...this.state[key] };
            keyState[index] = e;
            this.setState({
                [key]: keyState
            })
        } else {
            this.setState({
                [key]: e.target.value
            })
        }
    }

    handleWatchlistChange(val) {
        this.setState({
            selectedWatchlists: val
        });
    }

    handleSaveWatchlistss(watchlists, callback) {
        this.setState({
            saving: true
        }, () => {
            const bill = this.state.billData;
            let saveWatchlists = this.props.collection.collections.filter(w => watchlists.find(ww => w.WatchListID === ww.WatchListID));
            if (saveWatchlists.length > 0) {
                saveWatchlists = saveWatchlists.map(w => {
                    const toReturn = { ...w };
                    const watchlistBillIndex = w.WatchListLegislation.findIndex(cBill => bill.LegislationID === cBill.LegislationID && !cBill.DeletionDate);
                    toReturn.WatchListLegislation[watchlistBillIndex].Note = watchlists.find(ww => w.WatchListID === ww.WatchListID)?.Note ?? '';
                    return toReturn;
                });
                this.props.actions.saveCollections({ WatchLists: saveWatchlists })
                    .then(() => {
                        this.props.actions.makeToast([{ message: "Watchlist(s) Updated", type: "success" }]);
                        this.setState({
                            saving: false,
                        }, () => {
                            callback();
                        });
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        console.log(err)
                        this.setState({
                            saving: false
                        });
                        let message;
                        if (err && JSON.parse(err)) {
                            const errorMsg = JSON.parse(err).Name;
                            message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                        } else {
                            message = "Save Failed";
                        }
                        this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                    })
            } else {
                this.props.actions.makeToast([{ message: 'Failed to find watchlist', type: "failure" }]);
                this.setState({
                    saving: false
                });
            }
        })
    }

    addToWatchlists(watchlists, note) {
        let duplicatedBills = [];
        watchlists.forEach(watchlist => {
            //Replace each instance of bill with the bill details in state here
            if (watchlist.__isNew__) {
                watchlist.Name = watchlist.label;
                watchlist.Description = `Created on ${moment().tz('America/New_York').format('MM/DD/YYYY')}`;
                watchlist.WatchListLegislation = [];
                delete watchlist.label;
                delete watchlist.__isNew__;
                delete watchlist.value;
            }
            // Make sure the bill isn't already a part of the watchlist
            if (!watchlist.WatchListLegislation.find(leg => leg.LegislationID === this.state.billData.LegislationID) || watchlist.WatchListLegislation.find(leg => leg.LegislationID === this.state.billData.LegislationID).DeletionDate) {
                watchlist.WatchListLegislation.push({
                    LegislationID: this.state.billData.LegislationID,
                    LegislationNumber: this.state.billData.LegislationNumber,
                    Sessions: [{ SessionID: this.state.billData.SessionID }],
                    WatchListID: watchlist.WatchListID,
                    Note: note
                });
            } else {
                duplicatedBills.push({ "Watchlist": watchlist.Name, "LegislationNumber": this.state.billData.LegislationNumber });
            }
        })

        this.setState({
            collectionIsSaving: true
        }, () => {
            this.props.actions.saveCollections({ WatchLists: watchlists })
                .then(() => {
                    this.setState({
                        collectionIsSaving: false,
                        showWatchlistForm: false,
                        selectedWatchlists: []
                    });

                    this.getCollections("?SessionID=" + this.state.billData.SessionID)

                    if (duplicatedBills.length) {
                        this.props.actions.makeToast([{ message: duplicatedBills[0].LegislationNumber + " is already in " + (watchlists.length === 1 ? "this watchlist. " : "one or more of these watchlists. "), type: "warning", long: true }]);
                    } else {
                        this.props.actions.makeToast([{ message: this.state.billData.LegislationNumber + " was added to your watchlist" + (watchlists.length > 1 ? "s" : (" " + watchlists[0].Name)), type: "success" }]);
                    }
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        collectionIsSaving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        });
    }

    getCollections(params) {
        this.setState({
            collectionIsLoading: true
        });
        return Promise.resolve(this.props.actions.getCollections(params)
            .then(() => {
                const parsed = queryString.parse(this.props.location.search);
                const collectionIndex = this.props.collection.collections.findIndex(coll => coll.WatchListID === parseInt(parsed.collection))
                this.setState({
                    collectionIsLoading: false,
                }, () => {
                    if (collectionIndex !== -1) {
                        this.selectCollection(collectionIndex)
                    }
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return Promise.reject(err)
                }
                this.setState({
                    collectionIsLoading: false
                });
            })
        )
    }

    async submitImpactStatement(description, agency, file) {
        let params = "?legislationNumber=" + this.props.params.billnumber
            + "&sessionCode=" + this.props.params.sessionCode
            + "&referenceNumber=" + this.state.statementDocumentcode + "F" + agency.AgencyNumber
            + "&description=" + description

        this.setState({
            statementSubmitting: true
        }, () => {
            this.props.actions.uploadImpactStatement(params, file)
                .then(() => {
                    this.setState({
                        statementSubmitting: false
                    }, () => {
                        this.closeStatementForm();
                    })
                    this.props.actions.makeToast([{ message: "Impact Statement Upload Successful", type: "success" }]);
                })
                .catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    this.setState({
                        statementSubmitting: false
                    });
                    this.props.actions.makeToast([{ message: "Impact Statement Upload Failed", type: "failure" }]);
                })
        })
    }

    togglehideAllEvents() {
        this.setState({
            hideAllEvents: !this.state.hideAllEvents
        })
    }

    checkForDuplicates(summary) {
        let results = summary.match(/[H|S][B|J|R][\s|&nbsp;]+[0-9]+/g);
        if (results) {
            //.trim() and .replace(" ", "") both didn't work, even after being run through .toString(). I'm just glad this works. - JGB
            results.forEach((match) => {
                let breaklessMatch = match.replace('&nbsp;', ' ')
                let billNum = breaklessMatch.slice(0, 2) + breaklessMatch.slice(3);
                let link = `<a href="/bill-details/` + this.state.billData.SessionCode + `/` + billNum + `">` + breaklessMatch + `</a>`;
                summary = summary.replace(match, link);
            });
            return summary
        } else {
            return summary
        }
    }

    toggleDeleteSummaryModal(summary, summaryIndex) {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            summaryToDelete: { ...summary, index: summaryIndex }
        })
    }

    togglePatronModal() {
        this.props.history.push({
            pathname: `/bill-details/${this.state.billData.SessionCode}/${this.state.billData.LegislationNumber}/text/${this.state.versionsList.find(v => v.LegislationVersion === "Introduced")?.DocumentCode}`,
            state: { patronUpdate: true }
        })
    }

    handleToggleDescriptionEdit(index) {
        let versionsList = this.state['slideVersions'] ? [...this.state.versionsList] : [...this.state.versionsList.filter(version => version.IsActive === true || (version.TextDisposition === "Offered" && version.CommitteeID !== undefined))];
        if (versionsList.length > 0) {
            if (versionsList[index].editing === undefined) {
                versionsList[index].editing = true;
                versionsList[index].tempDescription = versionsList[index].Description;
            } else {
                versionsList[index].editing = !versionsList[index].editing;
            }
            this.setState({
                versionsList
            })
        }
    }

    handleDescriptionChange(value, index) {
        let versionsList = this.state['slideVersions'] ? [...this.state.versionsList] : [...versionsList.filter(version => version.IsActive === true || (version.TextDisposition === "Offered" && version.CommitteeID !== undefined))];
        versionsList[index].tempDescription = value;
        this.setState({
            versionsList
        })
    }

    saveVersionDescription(index) {
        let bill = this.state['slideVersions'] ? { ... this.state.versionsList[index] } : { ...versionsList.filter(version => version.IsActive === true || (version.TextDisposition === "Offered" && version.CommitteeID !== undefined))[index] };
        bill.Description = bill.tempDescription;
        this.props.actions.saveBillText({ TextsList: [bill] })
            .then(() => {
                this.getBillVersion(this.props.params.billnumber, this.props.params.sessionCode);
            });
    }

    handleNoteTextChange(e) {
        this.setState({
            noteText: e.target.value
        })
    }

    handleNoteWatchlistChange(value) {
        this.setState({
            noteWatchlists: value,
        })
    }

    handleSaveWatchlist(note, callback) {
        this.setState({
            saving: true
        }, () => {
            const bill = this.state.billData;
            const watchlist = this.props.collection.collections.find(w => w.WatchListID === note.WatchListID);
            if (watchlist) {
                const watchlistBillIndex = watchlist.WatchListLegislation.findIndex(cBill => bill.LegislationID === cBill.LegislationID && !cBill.DeletionDate);
                if (watchlistBillIndex > -1) {
                    watchlist.WatchListLegislation[watchlistBillIndex].Note = note.Note;
                }
                this.props.actions.saveCollections({ WatchLists: [watchlist] })
                    .then(() => {
                        this.props.actions.makeToast([{ message: "Watchlist(s) Updated", type: "success" }]);
                        this.setState({
                            saving: false,
                        }, () => {
                            callback();
                        });
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        console.log(err)
                        this.setState({
                            saving: false
                        });
                        let message;
                        if (err && JSON.parse(err)) {
                            const errorMsg = JSON.parse(err).Name;
                            message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                        } else {
                            message = "Save Failed";
                        }
                        this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                    })
            } else {
                this.props.actions.makeToast([{ message: 'Failed to find watchlist', type: "failure" }]);
                this.setState({
                    saving: false
                });
            }
        })
    }

    handleSaveWatchlists() {
        this.setState({
            saving: true
        }, () => {
            const bill = this.state.billData;
            let selectedWatchlists = [...this.state.noteWatchlists];
            selectedWatchlists.forEach(watchlist => {
                if (watchlist.__isNew__) {
                    watchlist.Name = watchlist.label;
                    watchlist.Description = `Created on ${moment().tz('America/New_York').format('MM/DD/YYYY')}`;
                    watchlist.WatchListLegislation = [];
                    delete watchlist.label;
                    delete watchlist.__isNew__;
                    delete watchlist.value;
                }

                const watchlistBillIndex = watchlist.WatchListLegislation.findIndex(cBill => bill.LegislationID === cBill.LegislationID && !cBill.DeletionDate);
                if (watchlistBillIndex > -1) {
                    watchlist.WatchListLegislation[watchlistBillIndex].Note = this.state.noteText;
                } else {
                    watchlist.WatchListLegislation.push({
                        LegislationID: this.state.billData.LegislationID,
                        LegislationNumber: this.state.billData.LegislationNumber,
                        Sessions: [{ SessionID: this.state.billData.SessionID }],
                        WatchListID: watchlist.WatchListID,
                        Note: this.state.noteText
                    })
                }
            })

            this.props.actions.saveCollections({ WatchLists: selectedWatchlists })
                .then(() => {
                    this.props.actions.makeToast([{ message: "Watchlist(s) Updated", type: "success" }]);
                    this.setState({
                        saving: false,
                        noteWatchlists: [],
                        noteText: "",
                    });
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        saving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        })
    }

    handleRemoveWatchlists(watchlistIdsToDelete) {
        this.setState({
            saving: true
        }, () => {
            const bill = this.state.billData;
            let selectedWatchlists = this.props.collection.collections.filter(w => watchlistIdsToDelete.includes(w.WatchListID));
            selectedWatchlists.forEach(watchlist => {
                const watchlistBillIndex = watchlist.WatchListLegislation.findIndex(cBill => bill.LegislationID === cBill.LegislationID && !cBill.DeletionDate);
                watchlist.WatchListLegislation[watchlistBillIndex].DeletionDate = new Date();
            })

            this.props.actions.saveCollections({ WatchLists: selectedWatchlists })
                .then(() => {
                    this.props.actions.makeToast([{ message: "Watchlist(s) Removed", type: "success" }]);
                    this.setState({
                        saving: false,
                        noteWatchlists: [],
                        noteText: "",
                    });
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        saving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        })
    }

    toggleWatchlistList() {
        this.setState({
            showWatchlistList: !this.state.showWatchlistList
        })
    }

    toggleReportMaker() {
        this.setState({
            showReportMaker: !this.state.showReportMaker
        })
    }

    addCommitteeLink(historyItem) {
        let linkedDescription = historyItem.Description;
        let committee, subcommittee;

        try {
            if (historyItem.Description &&
                historyItem.IsPublic &&
                historyItem.ReferenceType === "Committee" &&
                !historyItem.Description.includes("Pending") &&
                !historyItem.Description.includes("recommend")) {
                committee = this.state.committeeList.find(x =>
                    historyItem.Description.replace(/ /g, '').toLowerCase().includes(x.Name.replace(/ /g, '').toLowerCase())
                    && x.ChamberCode === historyItem.ChamberCode[0]
                    && historyItem.Description !== "Rules suspended");

                linkedDescription = linkedDescription.replace(committee.Name, '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + committee.CommitteeNumber + '/committee-details"' + '>' + committee.Name + '</a>')
                return linkedDescription;
            } else if (historyItem.Description &&
                historyItem.IsPublic &&
                historyItem.ReferenceType === "Subcommittee" &&
                !historyItem.Description.includes("Pending") &&
                !historyItem.Description.includes("recommend")) {
                committee = this.state.committeeList.find(x => x.Name === historyItem.ParentCommitteeName)
                subcommittee = this.state.committeeList.find(x =>
                    x.ParentCommitteeID === committee.CommitteeID
                    && x.Name.includes(historyItem.CommitteeName)
                );

                linkedDescription = linkedDescription.replace(linkedDescription.substring(linkedDescription.toLowerCase().indexOf("sub: ") + 5, linkedDescription.length), '<a href="/session-details/' + this.state.billData.SessionCode + '/committee-information/' + subcommittee.CommitteeNumber + '/committee-details"' + '>' + historyItem.CommitteeName + '</a>')
                return linkedDescription;
            } else {
                return historyItem.Description;
            }
        } catch (err) {
            console.log(err)
            return historyItem.Description;
        }
    }

    handlePrint(e) {
        e.preventDefault();
        const printWindow = this.printRef.current;
        if (printWindow) {
            printBillDetails(printWindow, 'old', this.state.billData, this.props.collection.collections, this.state['slidePatron'],
                this.state.patronList, this.state.sessionData, this.state['slideSummaries'] ? this.state.summariesList : [this.state.summariesList[0]]);
        }
    }

    render() {
        const { sessionData, summariesList, historyList, billData, senatePatronsList, housePatronsList, chiefPatronsList, versionsList, editing, description, saving, patronList } = this.state;
        // Show the active and offered versions when drawer is collapsed. If there are no active or offered versions then just display the last item
        let activeVersions = versionsList.filter(version => version.IsActive === true || (version.TextDisposition === "Offered" && version.CommitteeID !== undefined) || (version.TextDisposition === "Recommended"));
        if (activeVersions.length === 0) {
            activeVersions = [versionsList[versionsList.length - 1]];
        }
        let billSummary = '';
        if (summariesList.length > 0) {
            billSummary = summariesList[0];
        }
        const sessionHeader = sessionData && !isStatic ? sessionData.SessionYear + ' ' + sessionData.DisplayName : '';
        const billHeader = billData && !isStatic ? <React.Fragment>
            <div style={{ display: "inline-flex", marginTop: "5px" }}>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1) > -1)
                    ? <div className="nav-arrow-left" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1)].LegislationNumber)}></div>
                    : <div />
                }
                <span style={{ height: "22px" }}>{billData.LegislationNumber}</ span>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1) < this.props.bills.storedFullLegislationList.length && this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) > -1)
                    ? <div className="nav-arrow-right" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1)].LegislationNumber)}></div>
                    : <div />
                }
                {!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR) &&
                    <button type="button" className="button small-button edit-toggle remove-from-print" style={{ fontSize: '0.8em', height: "28px" }} onClick={this.toggleEditContent}>Edit History</button>
                }
            </div>
            <br />
            <span>{renderHTML(billData.Description || '')}</span>
            {this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR) && <a className="icon edit" style={{ marginLeft: "5px" }} onClick={() => this.toggleEdit(DESCRIPTION, this.state.billData.Description)}></a>}
        </React.Fragment> : '';

        const billHeaderEditor = <div className="bill-description-editor">
            <div style={{ display: "inline-flex", marginTop: "5px" }}>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1) > -1)
                    ? <div className="nav-arrow-left" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) - 1)].LegislationNumber)}></div>
                    : <div />
                }
                <span style={{ height: "22px" }}>{billData.LegislationNumber}</ span>
                {((this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1) < this.props.bills.storedFullLegislationList.length && this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) > -1)
                    ? <div className="nav-arrow-right" onClick={() => this.props.history.push("/bill-details/" + this.state.billData.SessionCode + "/" + this.props.bills.storedFullLegislationList[(this.props.bills.storedFullLegislationList.findIndex(x => x.LegislationNumber === this.state.billData.LegislationNumber) + 1)].LegislationNumber)}></div>
                    : <div />
                }
                {!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR) &&
                    <button type="button" className="button small-button edit-toggle remove-from-print" style={{ fontSize: '0.8em', height: "28px" }} onClick={this.toggleEditContent}>Edit History</button>
                }
            </div>
            <br />
            <input value={description} onChange={(e) => this.handleChange(DESCRIPTION, e)} disabled={saving[DESCRIPTION]} />
            {saving[DESCRIPTION]
                ? <div className="small-spinner"></div>
                : <div style={{ display: "inline-flex" }}><a className="icon save" onClick={() => this.saveDescription()}></a>
                    <a className="icon delete" onClick={() => this.toggleEdit(DESCRIPTION)}></a></div>
            }
        </div>;

        const formatSummaryVersion = (billSummary) => (
            billSummary.SummaryVersion.toLowerCase().split("").map((x, i) => { return billSummary.SummaryVersion[i - 1] === " " || i === 0 ? x.toUpperCase() : x })
        )

        const billSummaryEditor = index => <div className="bill-summary-editor">
            <Editor
                disabled={saving[SUMMARY] && saving[SUMMARY][index]}
                value={this.state.summary[index]}
                init={{
                    browser_spellcheck: true,
                    height: 350,
                    plugins: 'link paste save lists preview searchreplace pagebreak code table',
                    toolbar: 'undo redo | bold italic strikethrough | alignleft aligncenter alignright',
                    skin: false,
                    valid_children: '+body[style]',
                    content_css: false,
                    content_style: 'table { border-collapse: collapse; border: 1px solid #FFFFFF }' + 'td { padding: 12px 0px }',
                    formats: {
                        sumtext: {
                            block: 'p', attributes: { class: 'sumtext' }
                        }
                    },
                    style_formats: [
                        { title: "Sumtext", format: "sumtext" },
                    ],
                }}
                onEditorChange={content => this.handleChange(SUMMARY, content, index)}
            />
            {saving[SUMMARY] && saving[SUMMARY][index]
                ? <div className="small-spinner"></div>
                : <React.Fragment><a className="icon save" onClick={() => this.saveSummary(index)}></a>
                    <a className="icon delete" onClick={() => this.toggleEdit(SUMMARY, null, index)}></a></React.Fragment>
            }
        </div>;

        if (!this.state.billDataIsLoaded) {
            return (
                <div><LoaderComponent className="center-spinner" data={false} /></div>
            )
        } else if (!billData) {
            //Bill Data has been loaded but if it is empty then there have been zero results returned from the server
            return (<p>Bill data could not be found</p>)
        }
        return (
            <div id="bill-details" className="bill-theme public-details inner-grid" ref={el => (this.componentRef = el)}>
                {this.state.showReportMaker &&
                    <ReportMaker
                        toggleReportMaker={this.toggleReportMaker}
                        billList={[this.state.billData]}
                        collections={this.state.noteWatchlists}
                        selectedCollection={{ Name: this.state.billData.LegislationNumber + " Report" }}
                        autoReport={false}
                        reportTitle={this.state.billData.LegislationNumber + " Report"}
                        history={this.props.history}
                    />
                }
                {this.state.showDeleteModal &&
                    <div className='schedule-modal'>
                        <div className='schedule-modal-content'>
                            <div className='grid-wrapper'>
                                <div className='inner-grid eight-one-and-one'>
                                    <span>Are you sure you want to delete this summary ({formatSummaryVersion(this.state.summaryToDelete)})?</span>
                                    {saving[SUMMARY] && saving[SUMMARY][this.state.summaryToDelete.index]
                                        ? <div className="small-spinner"></div>
                                        : <button className='button primary' onClick={() => this.saveSummary(this.state.summaryToDelete.index, true)}>Yes</button>
                                    }
                                    <button className='button secondary' onClick={() => this.toggleDeleteSummaryModal()}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {!isStatic &&
                    <div style={{ borderBottom: "1px solid #CCC", display: "inline-flex" }}>
                        <h2 style={{ marginBottom: "5px", marginTop: "0", border: "0", whiteSpace: "nowrap", padding: 0 }}>{sessionHeader}</h2>
                        <div style={{ width: "100%" }} />
                        {!this.state.displayStatementForm &&
                            <div className={`flex-row ${!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR) ? 'space-around' : 'flex-end'}`} style={{ marginTop: "10px", height: "24px" }}>
                                <a type="button" className="button print remove-from-print" onClick={this.handlePrint}></a>
                                <button className='button primary remove-from-print report-toggle small-button' style={{ margin: "0 0 0 5px", padding: "0px 8px", height: "24px" }} onClick={() => this.toggleReportMaker()}>Create Report</button>
                            </div>
                        }
                    </div>
                }
                {!isStatic &&
                    <div className="details-header bill-details-header">
                        <h3 style={{ marginBottom: "20px" }}>{!editing[DESCRIPTION] ? billHeader : billHeaderEditor}</h3>
                    </div>
                }
                <div>
                    <div style={this.state.editingHistory || this.state.displayStatementForm ? { display: 'none' } : { display: 'block' }}>
                        {this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) && billData && !isStatic &&
                            <Collections
                                billData={billData}
                                sessionId={this.props.session.selectedSession.SessionID}
                                noteWatchlists={this.state.noteWatchlists}
                                noteText={this.state.noteText}
                                handleNoteTextChange={this.handleNoteTextChange}
                                handleNoteWatchlistChange={this.handleNoteWatchlistChange}
                                selectStyle={selectStyle}
                                handleSaveWatchlists={this.handleSaveWatchlists}
                                handleRemoveWatchlists={this.handleRemoveWatchlists}
                                saving={this.state.saving}
                                handleSaveWatchlist={this.handleSaveWatchlist}
                                handleSaveWatchlistss={this.handleSaveWatchlistss}
                            />
                        }
                        {!isStatic &&
                            <div style={{ marginBottom: "20px" }} className="list-desc">
                                <h4>Status</h4>
                                <p>{billData.LegislationStatus}</p>
                            </div>
                        }
                        <div style={{ marginBottom: "0px" }} className={this.state['slidePatron'] ? 'parent-li slidedown-open' : 'parent-li slidedown-closed'}>
                            <div className="toggle-row">
                                <div className="description" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                    <h4 style={{ paddingRight: "10px", borderRight: chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1 ? "1px solid #CCC" : "0" }}>{chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1 ? "Patrons" : "Patron"}</h4>
                                    {chiefPatronsList.length + housePatronsList.length + senatePatronsList.length > 1 &&
                                        <div className="button-container">
                                            <label id="sr-patrons-drawer-label" className="arrow-down-label" onClick={this.toggleShowData.bind(this, 'slidePatron')}>All Patrons</label>
                                            <button aria-labelledby="sr-patrons-drawer-label" aria-expanded={!!this.state['slidePatron']} className="arrow-down" onClick={this.toggleShowData.bind(this, 'slidePatron')}>More info</button>
                                        </div>
                                    }
                                    {versionsList.find(v => v.LegislationVersion === "Introduced") && this.props.login.userClaims.claims.find(claim => claim.RoleName === "Admin" || (claim.Resource === PATRON_AUTHOR && claim.Scope === (this.state.billData.ChamberCode === "H" ? "House" : "Senate"))) &&
                                        <button className="button small-button" onClick={this.togglePatronModal}>Update Patrons</button>
                                    }
                                </div>
                            </div>
                        </div>
                        {!this.state.patronIsLoaded ? <LoaderComponent data={false} /> :
                            <div style={{ marginBottom: "20px" }}>
                                <div className="list-desc">
                                    <p style={this.state['slidePatron'] ? { marginBottom: "0px" } : { marginBottom: "20px" }}>Introduced by: <PatronList session={sessionData} patrons={chiefPatronsList} /></p>
                                </div>
                                {this.state['slidePatron'] &&
                                    <div className="patrons-list list-desc">
                                        {this.state.billData.ChamberCode === "H"
                                            ?
                                            <React.Fragment>
                                                {housePatronsList.length > 0 && <div><span>House: </span><PatronList session={sessionData} patrons={housePatronsList} list /></div>}
                                                {senatePatronsList.length > 0 && <div><span>Senate: </span><PatronList session={sessionData} patrons={senatePatronsList} list /></div>}
                                            </React.Fragment>
                                            :
                                            <React.Fragment>
                                                {senatePatronsList.length > 0 && <div><span>Senate: </span><PatronList session={sessionData} patrons={senatePatronsList} list /></div>}
                                                {housePatronsList.length > 0 && <div><span>House: </span><PatronList session={sessionData} patrons={housePatronsList} list /></div>}
                                            </React.Fragment>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {!this.state.summaryIsLoaded ? <LoaderComponent data={false} /> :
                            <div className="bill-details-summary">
                                <div className="list-desc">
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <h4 style={{ padding: '0px 10px 0px 0px', borderRight: "1px solid #CCC" }} className={summariesList.length > 1 ? 'with-arrow' : ''}>{formatSummaryVersion(billSummary)}</h4>
                                        {summariesList.length > 1 &&
                                            <div style={{ margin: "0 0 0 10px" }} className={this.state['slideSummaries'] ? 'parent-li slidedown-open' : 'parent-li slidedown-closed'}>
                                                <div className="button-container">
                                                    <label id="sr-summaries-drawer-label" className="arrow-down-label" onClick={this.toggleShowData.bind(this, 'slideSummaries')}>All Summaries</label>
                                                    <button aria-labelledby="sr-summaries-drawer-label" aria-expanded={!!this.state['slideSummaries']} className="arrow-down" onClick={this.toggleShowData.bind(this, 'slideSummaries')}>More info</button>
                                                </div>
                                            </div>
                                        }
                                        {(!editing[SUMMARY] || !editing[SUMMARY][0]) && this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR) &&
                                            <React.Fragment>
                                                <a className="icon edit" style={{ margin: "0px 7px" }} onClick={() => this.toggleEdit(SUMMARY, billSummary.Summary ? this.checkForDuplicates(billSummary.Summary) : '', 0)}></a>
                                                <a className="icon red-bin" onClick={() => this.toggleDeleteSummaryModal(billSummary, 0)}></a>
                                            </React.Fragment>
                                        }
                                    </div>
                                    <div className='summary-wrapper'>
                                        {!editing[SUMMARY] || !editing[SUMMARY][0]
                                            ? renderHTML(this.checkForDuplicates(billSummary.Summary) || '')
                                            : billSummaryEditor(0)
                                        }
                                    </div>
                                </div>
                                {this.state['slideSummaries'] &&
                                    <div className="list-desc" style={{ marginTop: "10px" }}>
                                        <span>
                                            {
                                                summariesList.map((summaries, i) => {
                                                    if (i > 0) {
                                                        return (
                                                            <div>
                                                                <div key={i} style={{ display: 'flex' }}> <p><strong>{summaries.SummaryVersion}</strong></p>
                                                                    {(!editing[SUMMARY] || !editing[SUMMARY][i]) && this.props.login.userClaims.resources.find(resource => resource === BILL_AUTHOR) &&
                                                                        <React.Fragment>
                                                                            <a className="icon edit" style={{ margin: "0px 7px" }} onClick={() => this.toggleEdit(SUMMARY, summaries.Summary ? this.checkForDuplicates(summaries.Summary) : '', i)}></a>
                                                                            <a className="icon red-bin" onClick={() => this.toggleDeleteSummaryModal(summaries, i)}></a>
                                                                        </React.Fragment>
                                                                    }
                                                                </div>
                                                                {!editing[SUMMARY] || !editing[SUMMARY][i] ?
                                                                    renderHTML(summaries.Summary ? this.checkForDuplicates(summaries.Summary) : '')
                                                                    :
                                                                    billSummaryEditor(i)
                                                                }
                                                            </div>
                                                        )
                                                    } else {
                                                        return false;
                                                    }

                                                })
                                            }
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                        <div>
                            <div style={{ marginBottom: "0px" }} className={this.state['slideVersions'] ? 'parent-li slidedown-open' : 'parent-li slidedown-closed'}>
                                <div className="toggle-row">
                                    <div className="table-container description">
                                        <div className="description" style={{ display: 'flex', alignItems: 'center' }}>
                                            <h4>Bill Versions</h4>
                                            <button onClick={this.toggleShowTooltip.bind(this)} className="button info" style={{ marginRight: "10px" }}>Info</button>
                                            {versionsList.length > 1 && versionsList.find(version => !version.IsActive) &&
                                                <div className="button-container" style={{ paddingLeft: "10px", borderLeft: "1px solid #CCC" }}>
                                                    <label id="sr-versions-drawer-label" className="arrow-down-label" onClick={this.toggleShowData.bind(this, 'slideVersions')}>{this.state.slideVersions ? "Hide All Versions" : "Show All Versions"}</label>
                                                    <button aria-labelledby="sr-versions-drawer-label" aria-expanded={!!this.state['slideVersions']} className="arrow-down" onClick={this.toggleShowData.bind(this, 'slideVersions')}>More info</button>
                                                </div>
                                            }
                                            {this.props.login.userClaims.resources.find(resource => resource === VERSION_AUTHOR) &&
                                                <Link to={`/bill-details/${sessionData.SessionCode}/${billData.LegislationNumber}/text/new-amendment`} className="button small-button remove-from-print" style={{ fontSize: "13px" }}>Create Amendment</Link>
                                            }
                                        </div>
                                        {this.state.toolTip &&
                                            <div className="info-box">
                                                <ol>
                                                    <li> Introduced - A bill that has been introduced and referred to a committee. </li>
                                                    <li> Engrossed - A stage in the legislative process when a bill passes the second reading in the house of origin. If amended, the engrossed version of the legislation is printed incorporating all amendments that are agreed to. If not amended, the introduced version of the legislation becomes the engrossed bill, and if an amendment in the nature of a substitute is agreed to, the substitute becomes the engrossed bill.</li>
                                                    <li> Enrolled - Legislation which has passed both the Senate and the House of Delegates. It has been signed by the President of the Senate and the Speaker of the House and it has been sent to the Governor, but not yet signed. If signed by the Governor, the bill becomes a law and a Chapter of the Acts of Assembly.</li>
                                                    <li> Chaptered - A bill passed and signed into law by the Governor. The term also applies to constitutional amendments passed by the General Assembly and to bills passed notwithstanding the Governor’s objections or amendments.</li>
                                                    <li> Substitute - The redrafting of legislation that incorporates proposed changes in a new version. </li>
                                                </ol>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="line-table">
                                {!this.state.versionsIsLoaded ? (<LoaderComponent data={false} />) : (
                                    <React.Fragment>
                                        {versionsList.length > 0 &&
                                            <div>
                                                {this.state['slideVersions'] ?
                                                    <VersionList userClaims={this.props.login.userClaims} descriptionEditable={true} handleDescriptionChange={this.handleDescriptionChange} handleToggleDescriptionEdit={this.handleToggleDescriptionEdit} saveDescription={this.saveVersionDescription} version={versionsList} toggleStatementForm={this.toggleStatementForm} legislationClass={billData.LegislationClass} />
                                                    :
                                                    <VersionList userClaims={this.props.login.userClaims} descriptionEditable={true} handleDescriptionChange={this.handleDescriptionChange} handleToggleDescriptionEdit={this.handleToggleDescriptionEdit} saveDescription={this.saveVersionDescription} version={activeVersions} toggleStatementForm={this.toggleStatementForm} legislationClass={billData.LegislationClass} />
                                                }
                                            </div>
                                        }
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        {!this.state.displayStatementForm &&
                            <React.Fragment>
                                <h4 style={{ display: 'inline-block', marginRight: '8px' }}>History</h4>
                                {!this.state.editingHistory && this.props.login.userClaims.claims.find(claim => claim.RoleName === BILL_EVENT_AUTHOR) &&
                                    <button type="button" className="button small-button" style={{ fontSize: '0.8em' }} onClick={this.toggleEditContent}>Edit</button>
                                }
                            </React.Fragment>}
                        {this.state.editingHistory && this.state.historyIsLoaded ?
                            <BillHistoryForm
                                switchedToBill={this.state.switchedToBill}
                                legislationNumber={this.state.legislationNumber}
                                historyList={historyList}
                                organizedEvents={this.state.organizedEvents}
                                handleEventChange={this.handleEventChange}
                                billEvents={this.state.billEvents}
                                billData={this.state.billData}
                                toggleEditContent={this.toggleEditContent}
                                saveEvents={this.saveEvents}
                                hideAllEvents={this.state.hideAllEvents}
                                togglehideAllEvents={this.togglehideAllEvents}
                                changeToNewBillHistoryForm={this.changeToNewBillHistoryForm}
                                actionTypes={this.state.actionTypes}
                                memberList={this.state.memberList}
                                committeeList={this.state.committeeList}
                                versionsList={this.state.versionsList.map(text => ({
                                    ...text,
                                    label: text.DocumentCode + " " + text.Description,
                                    value: text.LegislationTextID
                                }))}
                                reconsiderationEvents={this.state.reconsiderationEvents}
                                getReconsiderationEvents={this.getReconsiderationEvents}
                            />
                            :
                            <React.Fragment>
                                {!this.state.historyIsLoaded ? <LoaderComponent data={false} /> :
                                    !this.state.displayStatementForm &&
                                    <React.Fragment>
                                        <table className="line-table">
                                            <tbody>
                                                {historyList.filter(item => !item.DeletionDate).map((item, index) => (
                                                    <tr key={index} className={`parent-tr ${item.opened ? 'slidedown-open' : 'slidedown-closed'} bill-details-table-row${item.IsPublic ? '' : ' not-public'}`}>
                                                        <td className="left">{moment(item.EventDate).tz('America/New_York').format('l')}</td>
                                                        <td className="left">{item.ActorType}</td>
                                                        <td className="left">
                                                            <span dangerouslySetInnerHTML={{ __html: ["House", "Senate"].includes(item.ActorType) ? this.addCommitteeLink(item) : item.Description }} />
                                                            {item.VoteLinks && item.opened &&
                                                                <div className="link-row">
                                                                    {item.VoteLinks.map((link, index) =>
                                                                        <div key={index}>
                                                                            {link.VoteID && item.VoteTally !== "(Voice Vote)" ? link.IsPublic ? <Link to={`/vote-details/${this.state.billData.LegislationNumber}/${item.SessionCode}/${link.VoteNumber}`}>Vote</Link> : <span>Vote Detail Pending</span> : ''}
                                                                            {/* link.CommitteeNumber ? <Link to={`/session-details/${item.SessionCode}/committee-information/${link.CommitteeNumber}/committee-details`}>{link.ParentCommitteeID ? 'Subcommittee' : 'Committee'}</Link> : '' */}
                                                                            {link.LegislationNumber && link.SessionCode ? <Link to={`/bill-details/${link.SessionCode}/${link.LegislationNumber}`}>Legislation</Link> : ''}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            }
                                                        </td>
                                                        <td className="button-container">
                                                            {/* item.ReferenceType && item.ReferenceType.toLowerCase() === "committee" ||
                                                                item.ReferenceType && item.ReferenceType.toLowerCase() === "subcommittee" || */
                                                                item.ReferenceType && item.ReferenceType.toLowerCase() === "legislation" ||
                                                                    item.VoteID && item.ReferenceType && item.ReferenceType.toLowerCase() === "vote" && item.VoteTally !== "(Voice Vote)"
                                                                    ? <React.Fragment>
                                                                        {item.isLoading ?
                                                                            <span className="small-spinner"></span>
                                                                            :
                                                                            <button className="arrow-down" onClick={() => this.toggleShowLinks(item)}>Show links</button>
                                                                        }
                                                                    </React.Fragment>
                                                                    : null
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </div>
                    <div>
                        {this.state.displayStatementForm &&
                            <ImpactStatementForm
                                submit={this.submitImpactStatement}
                                isSubmitting={this.state.statementSubmitting}
                                toggleStatementForm={this.toggleStatementForm}
                                statementDate={this.state.statementDate}
                                statementDescription={this.state.statementDescription}
                                agencyOptions={this.state.agencyOptions}
                            />
                        }
                    </div>
                </div>
                <iframe ref={this.printRef} width="0" height="0" frameBorder="0" src="about:blank"></iframe>
            </div >
        )
    }
}

const OldPublicBillDetails = connect(
    (state) => {
        const { bills, session, patrons, votes, login, nav, minutes, members, committee, organizations, collection } = state;
        return {
            bills,
            session,
            patrons,
            votes,
            login,
            nav,
            minutes,
            members,
            committee,
            organizations,
            collection
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, voteActionCreators, billActionCreators, sessionActionCreators, patronActionCreators, authActionCreators, navActionCreators, minutesActionCreators, memberActionCreators, committeeActionCreators, orgActionCreators, collectionActionCreators), dispatch)
        }
    }
)(OldBillDetailsComponent)

export default OldPublicBillDetails;
